import { useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Megaphone, AlertTriangle, Send } from "lucide-react";

export default function AdminBroadcast() {
  const [text, setText] = useState("");
  const [viaWa, setViaWa] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (!text.trim()) return;
    if (!confirmed) { toast.error("Confirma antes de enviar."); return; }
    setSending(true);
    try {
      const { data } = await api.post("/admin/broadcast", { text, via_whatsapp: viaWa });
      toast.success(`Enviado para ${data.sent_chat} corretores no chat${viaWa ? `, ${data.sent_whatsapp} pelo WhatsApp` : ''}`);
      setText(""); setViaWa(false); setConfirmed(false);
    } catch (e) { toast.error("Erro ao enviar"); }
    finally { setSending(false); }
  };

  return (
    <div className="p-6 lg:p-10 max-w-3xl mx-auto space-y-5" data-testid="admin-broadcast-root">
      <header>
        <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4651A] font-bold mb-1">Megafone</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-[#1B3A2F] flex items-center gap-3">
          <Megaphone className="w-7 h-7 text-[#D4651A]" /> Comunicado geral
        </h1>
        <p className="text-stone-500 mt-2 text-sm">Manda uma mensagem pra todos os corretores ativos. Usa com responsabilidade.</p>
      </header>

      <Card className="p-6 rounded-2xl space-y-4">
        <div>
          <Label>Mensagem</Label>
          <Textarea
            data-testid="admin-broadcast-input"
            rows={6}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Ex: Galera, lançamento novo em Pinheiros chegou. Quem trabalha região, me chama no DM..."
            className="mt-1.5"
          />
          <p className="text-xs text-stone-500 mt-1">{text.length} caracteres</p>
        </div>

        <div className="flex items-center gap-2">
          <Checkbox id="via-wa-bc" checked={viaWa} onCheckedChange={setViaWa} data-testid="admin-broadcast-via-wa" />
          <Label htmlFor="via-wa-bc" className="cursor-pointer text-sm">Enviar também pelo WhatsApp (custo Twilio aplicado)</Label>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex gap-3">
          <AlertTriangle className="w-5 h-5 text-amber-700 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-semibold text-amber-900">Atenção</p>
            <p className="text-xs text-amber-800 mt-0.5">
              Essa mensagem vai pra todos os corretores ativos. Não dá pra desfazer. Confirma o conteúdo antes.
            </p>
            <div className="flex items-center gap-2 mt-2">
              <Checkbox id="confirm-bc" checked={confirmed} onCheckedChange={setConfirmed} data-testid="admin-broadcast-confirm" />
              <Label htmlFor="confirm-bc" className="cursor-pointer text-xs text-amber-900">Confirmo que revisei o conteúdo e quero enviar</Label>
            </div>
          </div>
        </div>

        <Button
          data-testid="admin-broadcast-send-btn"
          onClick={send}
          disabled={!text.trim() || !confirmed || sending}
          className="w-full bg-[#1B3A2F] hover:bg-[#244A3C]"
        >
          <Send className="w-4 h-4 mr-2" />
          {sending ? "Enviando..." : "Enviar comunicado"}
        </Button>
      </Card>
    </div>
  );
}
